import React, { useState } from 'react';
import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import AppSidebar from './sidebar/sidebar.component';
import AppHeader from './header/header.component';
import { NavLinkType, SubLink } from '../../type/navlink.types';
import useAuth from '../../hooks/useAuth';
import { Roles } from '../../enums/roles-enum';
import {
  Home,
  BuildingStore,
  Checklist,
  Link,
  Book,
  History,
  Forms,
  FileReport,
  Users,
  Devices,
  LetterP,
  LetterR,
  LetterM,
  LetterB,
} from 'tabler-icons-react';

const CheckerDashboardLayout = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);

  const { auth } = useAuth();

  // for settlement and admin role only
  let navLinkProps: NavLinkType[] = [
    {
      order: 1,
      link: '/admin',
      label: 'Dashboard',
      icon: Home,
    },
    {
      order: 2,
      link: '/admin/onboarding',
      label: 'Onboarding',
      icon: Checklist,
    },
    {
      order: 3,
      link: '/admin/partners',
      label: 'Partners',
      icon: LetterP,
    },
    {
      order: 4,
      link: '/admin/resellers',
      label: 'Resellers',
      icon: LetterR,
    },
    {
      order: 5,
      link: '/admin/merchants',
      label: 'Merchants',
      icon: LetterM,
    },
    {
      order: 6,
      link: '/admin/branches',
      label: 'Branches',
      icon: LetterB,
    },
    {
      order: 7,
      link: 'admin/users',
      label: 'User Management',

      icon: Users,
    },
    {
      order: 8,
      sublinks: [{ link: 'admin/mids', label: 'View All MIDs' }],
      link: '',
      label: 'MID',
      icon: Forms,
    },
    {
      order: 9,
      sublinks: [{ link: 'admin/pos', label: 'View All POSs' }],
      link: '',
      label: 'POS',
      icon: Devices,
    },
  ];

  const repositionLinks = () => {
    return navLinkProps.sort((a, b) => {
      return a.order - b.order;
    });
  };

  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <AppShell
        styles={{
          main: {
            background:
              theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
            '@media (max-width: 992px)': {
              paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
            },
          },
        }}
        navbarOffsetBreakpoint='md'
        asideOffsetBreakpoint='md'
        fixed
        navbar={<AppSidebar navLinkProps={repositionLinks()} opened={opened} />}
        header={<AppHeader opened={opened} setOpened={setOpened} />}
      >
        <Outlet />
      </AppShell>
    </MantineProvider>
  );
};

export default CheckerDashboardLayout;
